import React from 'react';
import { makeCSS } from '../../utils/makeCSS';

export const useCubeAnchorLinkStyles = makeCSS(({ theme }) => {
  return {
    root: {
      textDecoration: 'none',
      color: theme.color.text['03'], // '#fff'
      '&:visited': {
        color: theme.color.text['03'] // 'rgba(255,255,255,0.48)'
      },
      '&:hover': {
        color: theme.color.text['02'] // 'rgba(255,255,255,0.64)'
      },
      '&:active, &:focus': {
        color: theme.color.text['01'] // 'rgba(255,255,255,0.64)'
      }
    },
    disabled: {
      pointerEvents: 'none'
    },
    'underline-true': {
      display: 'inline-block',
      borderBottom: `solid 1px ${theme.color.text['03']}`,
      '&:hover': {
        borderBottomColor: theme.color.text.dark['02']
      },
      '&:active, &:focus': {
        borderBottomColor: theme.color.text.dark['01']
      }
    },
    'underline-hover': {
      display: 'inline-block',
      borderBottom: `solid 1px transparent`,
      '&:hover': {
        borderBottomColor: theme.color.text.dark['02']
      },
      '&:active, &:focus': {
        borderBottomColor: theme.color.text.dark['01']
      }
    },
    inline: {
      display: 'inline'
    },
    'underline-false': {},
    brightText: { color: theme.color.text['01'] }
  };
});

export interface CubeAnchorLinkProps {
  href: string;
  target?: React.HTMLAttributeAnchorTarget;
  underline?: boolean;
  injectedClassName?: string;
  disabled?: boolean;
  onLinkClick?(e?: React.MouseEvent): void;
  /**When we want the original text to use text/01 */
  brightText?: boolean;
}
export const CubeAnchorLink: React.FC<
  React.PropsWithChildren<CubeAnchorLinkProps>
> = (props) => {
  const {
    href,
    target = '_blank',
    underline = false,
    injectedClassName = undefined,
    disabled = false,
    onLinkClick,
    brightText
  } = props;
  const classes = useCubeAnchorLinkStyles(props);

  return (
    <a
      className={`${classes.root} ${classes[`underline-${underline}`]} ${
        classes.inline
      }  ${injectedClassName} ${disabled ? classes.disabled : ''} ${
        brightText ? classes.brightText : ''
      }`}
      href={href}
      target={target}
      rel="noopener noreferrer"
      onClick={onLinkClick}
    >
      {props.children}
    </a>
  );
};
